type LegalVersion = {
  readonly version: string
  readonly effectiveDate: string
  readonly lastModified: string
  readonly changes: string
}

type LegalVersionMetaProps = {
  readonly current: LegalVersion
  readonly history: readonly LegalVersion[]
}

export function LegalVersionMeta({ current, history }: LegalVersionMetaProps) {
  return (
    <>
      <div className="not-prose mb-8 flex flex-wrap gap-6 rounded-md border border-border bg-muted/40 px-5 py-4 text-sm text-muted-foreground">
        <span>
          <span className="font-medium text-foreground">
            Version {current.version}
          </span>{' '}
          &mdash; effective {current.effectiveDate}
        </span>
        <span>Last modified: {current.lastModified}</span>
      </div>

      {history.length > 0 && (
        <div className="not-prose mt-16 border-t border-border pt-8">
          <h2 className="mb-4 text-base font-semibold text-foreground">
            Version history
          </h2>
          <ul className="space-y-3">
            {history.map((v) => (
              <li key={v.version} className="text-sm text-muted-foreground">
                <span className="font-medium text-foreground">
                  v{v.version}
                </span>{' '}
                &mdash; {v.effectiveDate} &mdash; {v.changes}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}
